import { Component, Input } from "@angular/core";

@Component({
    standalone: false,
    selector: 'mm-transmission-notes',
    templateUrl: './transmission-notes.component.html',
    styleUrls: ['./transmission-notes.component.scss']
})
export class TransmissionNotesComponent {
    @Input()transmissionNotes: string = '';
    @Input()transmissionNotesLabel: string = '';
    
    constructor() {}
}